import { Link } from "react-router-dom";
import { WEEKLY_DROPS, MENU_FEATURED_IMAGE } from "@/data/content";
import { ArrowUpRight } from "lucide-react";

export default function WeeklyDrops() {
  return (
    <div data-testid="drops-page" className="pt-28 md:pt-36 pb-24 md:pb-32">
      <section className="mx-auto max-w-[1400px] px-6 md:px-10">
        <div className="grid md:grid-cols-12 gap-10 items-end">
          <div className="md:col-span-7">
            <p className="label-eyebrow">Weekly Drops — Stewards First</p>
            <h1 className="font-display text-bone text-5xl md:text-7xl mt-5 leading-[0.95]">
              Sixty cups.<br />
              <em className="not-italic text-brass">One weekend.</em>
            </h1>
          </div>
          <div className="md:col-span-5 md:text-right">
            <p className="text-bone/70 max-w-md md:ml-auto">
              Every Friday at 7:00 a.m. local, we open a numbered drop. House Stewards
              receive 48 hours of early access. Everything else is gone by Sunday night.
            </p>
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6" data-testid="drops-grid">
          {WEEKLY_DROPS.map((d, i) => (
            <article
              key={d.code}
              data-testid={`drop-card-${i}`}
              className={`group relative border border-bone/10 hover:border-brass/40 transition-colors p-7 md:p-9 ${
                i === 0 ? "bg-espresso/30" : "bg-obsidian"
              }`}
            >
              <div className="flex items-center justify-between">
                <p className="label-eyebrow text-brass">{d.code}</p>
                <span
                  className={`text-[10px] uppercase tracking-[0.28em] px-3 py-1 ${
                    d.status === "Archived"
                      ? "text-bone/40 border border-bone/15"
                      : "text-obsidian bg-lavender"
                  }`}
                >
                  {d.status}
                </span>
              </div>

              <h3 className="font-display text-bone text-3xl md:text-4xl mt-8">{d.name}</h3>
              <p className="font-display italic text-bone/60 mt-2 text-lg">{d.window}</p>
              <p className="mt-6 text-bone/65 text-sm leading-relaxed min-h-[72px]">{d.desc}</p>

              <div className="mt-10 hairline" />
              <div className="mt-5 flex items-center justify-between text-[11px] uppercase tracking-[0.3em]">
                <span className="text-bone/45">House Edition</span>
                <span className="text-bone/45">60 cups</span>
              </div>
            </article>
          ))}
        </div>

        {/* Editorial banner */}
        <div className="mt-20 relative overflow-hidden border border-bone/10">
          <div className="absolute inset-0">
            <img src={MENU_FEATURED_IMAGE} alt="" className="h-full w-full object-cover opacity-50" />
            <div className="absolute inset-0 bg-gradient-to-r from-obsidian via-obsidian/70 to-obsidian/20" />
          </div>
          <div className="relative px-8 md:px-14 py-16 md:py-20 max-w-3xl">
            <p className="label-eyebrow text-lavender">How a Drop Works</p>
            <h3 className="font-display text-bone text-3xl md:text-5xl mt-4 leading-tight">
              Stewards get 48 hours of early access. Then the door opens for everyone else — until it doesn&apos;t.
            </h3>
            <Link
              to="/membership"
              data-testid="drops-join-cta"
              className="mt-10 inline-flex items-center gap-2 px-7 py-4 bg-brass text-obsidian text-[12px] uppercase tracking-[0.28em] hover:bg-champagne transition-colors"
            >
              Get Early Access <ArrowUpRight size={14} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
